import { Icon } from '@design/components/icon/Icon';
import * as Radix from '@radix-ui/react-dropdown-menu';
import filterStyles from '@terminal/components/filter/Filter.module.scss';
import { Option } from '@terminal/components/filter/Option';
import { AssetsFilterOption } from '@terminal/components/filters/components/utils';
import { ToggleFilterProps } from '@terminal/components/update-filter-options/updateFilterOptions';
import React from 'react';

interface AssetsOptionsListProps {
  filterKey: string;
  options: AssetsFilterOption[];
  isChecked: (key: string) => boolean;
  onFilterSelect: (props: ToggleFilterProps, active: boolean) => void;
  multiselect: boolean;
  isPending?: boolean;
}

export const AssetsOptionsList = ({
  options,
  isChecked,
  onFilterSelect,
  filterKey,
  multiselect,
  isPending,
}: AssetsOptionsListProps) => {
  return (
    <div className={filterStyles.scrollableList}>
      <div className={filterStyles.separator} />
      {options.map((option: AssetsFilterOption, idx: number) => {
        const { customHeaderTitle, hasBottomBorder, key } = option;
        const checked = isChecked(key);

        return (
          <div key={option.key || `cta-option-${idx}`}>
            {customHeaderTitle && (
              <div className={filterStyles.customHeaderLabel}>
                {customHeaderTitle}
              </div>
            )}
            {option.key ? (
              <Option
                option={option}
                isChecked={checked}
                disabled={isPending}
                handleClick={() =>
                  onFilterSelect(
                    {
                      option,
                      filterKey: filterKey,
                      filterId: filterKey,
                      multiselect,
                    },
                    checked
                  )
                }
                multiselect={multiselect}
              />
            ) : (
              <Radix.Item
                className={filterStyles.item}
                data-testid="custom-option-item"
                onClick={option.customOptionCallback}
              >
                <span
                  className={filterStyles.menuItemLeftIndicator}
                  data-menu-item-indicator
                />
                <div className={filterStyles.itemText} data-item-text>
                  <p className={filterStyles.customLabel}>
                    <Icon iconName="Add" size={14} />
                    <span>{option.customOptionLabel}</span>
                  </p>
                </div>
              </Radix.Item>
            )}
            {hasBottomBorder && (
              <div className={filterStyles.customBottomBorder} />
            )}
          </div>
        );
      })}
    </div>
  );
};
